module.exports = __webpack_public_path__ + "img/inteGif.3d8656ff.gif";